import { render, staticRenderFns } from "./ObjetivosOperadores.vue?vue&type=template&id=2ec2728e&scoped=true"
import script from "./ObjetivosOperadores.vue?vue&type=script&lang=js"
export * from "./ObjetivosOperadores.vue?vue&type=script&lang=js"
import style0 from "./ObjetivosOperadores.vue?vue&type=style&index=0&id=2ec2728e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2728e",
  null
  
)

export default component.exports